
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setShowBanner(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        className="fixed bottom-0 left-0 right-0 z-50 p-4 lg:p-6"
      >
        <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-200 p-6 lg:p-8">
          {!showSettings ? (
            <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
              <div className="flex-1">
                <h3 className="font-display font-semibold text-lg text-dark mb-2">
                  Uso de Cookies
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Utilizamos cookies propias y de terceros para mejorar nuestros servicios y mostrarle publicidad relacionada con sus preferencias mediante el análisis de sus hábitos de navegación. Puede obtener más información en nuestra{' '}
                  <a href="/cookies" className="text-primary hover:underline">
                    Política de Cookies
                  </a>
                  .
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
                <button
                  onClick={() => setShowSettings(true)}
                  className="px-6 py-2.5 border-2 border-gray-300 text-dark font-medium rounded-full hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Configurar
                </button>
                <button
                  onClick={acceptNecessary}
                  className="px-6 py-2.5 border-2 border-primary text-primary font-medium rounded-full hover:bg-primary/5 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Solo Necesarias
                </button>
                <button
                  onClick={acceptAll}
                  className="px-6 py-2.5 bg-primary text-white font-medium rounded-full hover:bg-primary/90 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Aceptar Todas
                </button>
              </div>
            </div>
          ) : (
            <div>
              <div className="flex items-center justify-between mb-6">
                <h3 className="font-display font-semibold text-lg text-dark">
                  Configuración de Cookies
                </h3>
                <button
                  onClick={() => setShowSettings(false)}
                  className="text-gray-400 hover:text-dark transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <div className="space-y-4 mb-6">
                <div className="flex items-start justify-between p-4 bg-gray-50 rounded-lg">
                  <div className="flex-1">
                    <h4 className="font-semibold text-dark mb-1">Cookies Necesarias</h4>
                    <p className="text-sm text-gray-600">
                      Esenciales para el funcionamiento del sitio web. No se pueden desactivar.
                    </p>
                  </div>
                  <div className="ml-4">
                    <input
                      type="checkbox"
                      checked
                      disabled
                      className="w-5 h-5 text-primary rounded cursor-not-allowed"
                    />
                  </div>
                </div>
                <div className="flex items-start justify-between p-4 bg-gray-50 rounded-lg">
                  <div className="flex-1">
                    <h4 className="font-semibold text-dark mb-1">Cookies Analíticas</h4>
                    <p className="text-sm text-gray-600">
                      Nos permiten analizar el uso del sitio web para mejorar el rendimiento.
                    </p>
                  </div>
                  <div className="ml-4">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="w-5 h-5 text-primary rounded cursor-pointer"
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={acceptNecessary}
                  className="flex-1 px-6 py-2.5 border-2 border-primary text-primary font-medium rounded-full hover:bg-primary/5 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Guardar Preferencias
                </button>
                <button
                  onClick={acceptAll}
                  className="flex-1 px-6 py-2.5 bg-primary text-white font-medium rounded-full hover:bg-primary/90 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Aceptar Todas
                </button>
              </div>
            </div>
          )}
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default CookieBanner;
